/**
 * @GENERATED from Figma node 3608:50998
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const AsanaDark = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="M18.218 12.585c-2.643 0-4.787 2.105-4.787 4.703 0 2.603 2.144 4.708 4.787 4.708 2.638 0 4.782-2.109 4.782-4.708 0-2.594-2.14-4.703-4.782-4.703m-12.436 0C3.144 12.585 1 14.694 1 17.293 1 19.896 3.144 22 5.782 22c2.643 0 4.787-2.109 4.787-4.707.004-2.6-2.14-4.708-4.787-4.708m11-5.878c0 2.6-2.14 4.704-4.782 4.704S7.218 9.306 7.218 6.707 9.358 2 12 2s4.782 2.109 4.782 4.707"
      />
      <defs>
        <radialGradient
          id={_id}
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(-90.449 13.127 1.137)scale(12.2733 13.2697)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC01B" />
          <stop offset={0.6} stopColor="#FF75A1" />
          <stop offset={0.999} stopColor="#FF7878" />
        </radialGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(AsanaDark);
export { ForwardRef as AsanaDark };
